















































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import Payee from '@/models/Accounts/Shared/Payees/Payee';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';
import Address from '@/models/Customers/Addresses/Address';
import CreatePayeeType from '@/models/Shared/CreatePayeeType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'PaymentOrderPayeeDetails' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    payeeType: CreatePayeeType;

    @Prop({required: true})
    newPayeeType: PayeeType;

    @Prop({required: true})
    selectedPayee: Payee;

    @Prop({required: true})
    payees: Payee[];

    @Prop({required: true})
    newPayeeAddress: Address;

    PayeeType = PayeeType;
    CreatePayeeType = CreatePayeeType;

    changePayeeType(payeeType: CreatePayeeType) {
        this.$emit('inputPayeeType', payeeType);
    }

    changeNewPayeeName(name: string) {
        this.$emit('inputNewPayeeName', name);
    }

    changeNewPayeeType(newPayeeType: PayeeType) {
        this.$emit('inputNewPayeeType', newPayeeType);
    }

    changeNewPayeeSortCode(sortCode: string) {
        this.$emit('inputNewPayeeSortCode', sortCode);
    }

    changeNewPayeeAccountNumber(accountNumber: string) {
        this.$emit('inputNewPayeeAccountNumber', accountNumber);
    }

    changeNewPayeeIban(iban: string) {
        this.$emit('inputNewPayeeIban', iban);
    }

    changeSelectedPayee(payee: Payee) {
        this.$emit('inputPayee', payee);
    }

    get payeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

    get countryOptions() {
        return ListUtils.countryOptions();
    }

}
